<div class="page-title fonb-list-header">
  <span class="fonb-list-heading">
    <span class="fonb-list-title">{{ 'FLEXI_ONBOARDING.TITLE' | translate }}</span>
    <span class="fonb-list-subtitle">{{ 'FLEXI_ONBOARDING.LIST.SUBTITLE' | translate }}</span>
  </span>
  <span class="page-actions">
    <button class="btn fonb-btn-primary" type="button" (click)="createNew()">
      <i class="pi pi-plus"></i>
      <span>{{ 'NEW' | translate }}</span>
    </button>
  </span>
</div>

<div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

<div class="table-view mbtm-30">
  <p-table
    [value]="forms"
    dataKey="id"
    [loading]="loading"
    [rows]="10"
    [paginator]="true"
    [pageLinks]="3"
    [rowsPerPageOptions]="[5, 10, 20]"
    paginatorDropdownAppendTo="body"
    [showCurrentPageReport]="true"
    [rowHover]="true"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm fonb-modern-table"
    currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
  >
    <ng-template pTemplate="caption">
      <div class="fonb-table-caption">
        <span class="fonb-record-count" *ngIf="forms.length">
          {{ forms.length }} {{ 'FLEXI_ONBOARDING.LIST.RECORD_LABEL' | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 160px">{{ 'FLEXI_ONBOARDING.LIST.COLUMN_CREATED_ON' | translate }}</th>
        <th style="min-width: 130px">{{ 'FLEXI_ONBOARDING.LIST.COLUMN_VALID_TILL' | translate }}</th>
        <th style="min-width: 170px">{{ 'FLEXI_ONBOARDING.LIST.COLUMN_CREATED_BY' | translate }}</th>
        <th style="min-width: 170px">{{ 'FLEXI_ONBOARDING.LIST.COLUMN_MODIFIED_BY' | translate }}</th>
        <th style="width: 140px">{{ 'FLEXI_ONBOARDING.LIST.COLUMN_STATUS' | translate }}</th>
        <th style="width: 150px; text-align: center">{{ 'ACTIONS' | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-form>
      <tr>
        <td>
          <a class="fonb-date-link" href="javascript:void(0)" (click)="open(form)">
            {{ form.createdOn | date: 'dd/MM/yyyy HH:mm' }}
          </a>
        </td>
        <td>
          <span *ngIf="form.validUntil; else noValidTill">
            {{ form.validUntil | date: 'dd/MM/yyyy' }}
          </span>
          <ng-template #noValidTill><span class="fonb-empty-cell">—</span></ng-template>
        </td>
        <td>
          <span *ngIf="form.createdByName; else noCreatedBy">{{ form.createdByName }}</span>
          <ng-template #noCreatedBy><span class="fonb-empty-cell">—</span></ng-template>
        </td>
        <td>
          <span *ngIf="form.modifiedByName; else noModifiedBy">{{ form.modifiedByName }}</span>
          <ng-template #noModifiedBy><span class="fonb-empty-cell">—</span></ng-template>
        </td>
        <td>
          <span class="fonb-status-pill" [ngClass]="isCompleted(form) ? 'is-completed' : 'is-open'">
            <i class="pi" [ngClass]="isCompleted(form) ? 'pi-check-circle' : 'pi-clock'"></i>
            {{ statusKey(form) | translate }}
          </span>
        </td>
        <td>
          <div class="fonb-row-actions">
            <button type="button" class="fonb-row-action" (click)="open(form)">
              <i class="pi" [ngClass]="isCompleted(form) ? 'pi-replay' : 'pi-pencil'"></i>
              {{ actionKey(form) | translate }}
            </button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">{{ 'FLEXI_ONBOARDING.LIST.EMPTY' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
